export default function LoadingAir() {
  return (
    <div className="bg-white">
      <div className="h-1 bg-white w-screen relative">
        <div className="h-1 bg-[#F6958C] absolute waiting-bg-air"></div>
        <svg
          className="absolute top-[-10px] waiting-air text-red-600"
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.5 24L10 24L16.25 13.8L23.125 13.8C24.1625 13.8 25 12.996 25 12C25 11.004 24.1625 10.2 23.125 10.2L16.25 10.2L10 -6.19336e-07L7.5 -7.22559e-07L10.625 10.2L3.75 10.2L1.875 7.2L1.57416e-06 7.2L1.25 12L1.12992e-06 16.8L1.875 16.8L3.75 13.8L10.625 13.8L7.5 24Z"
            fill="currentColor"
          />
        </svg>
      </div>
    </div>
  );
}
